// extracted by mini-css-extract-plugin
module.exports = {"numberOfPositionBriefs":"PositionBriefList_numberOfPositionBriefs__36Lc1","displayMore":"PositionBriefList_displayMore__9GSBi"};